import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import MyModal from '../../../../components/Modal';
import { ActionModalContainer } from '../styles';
import FormGroup from '../../../../components/FormGroup';
import OpacityAnimation from '../../../../components/OpacityAnimation';

interface ReactivateModalInterface {
  passengerName: string;
  isReactivateDateSet: boolean;
  setIsReactivateDateSet: Dispatch<SetStateAction<boolean>>;
  reactivateModalShow: boolean;
  setReactivateModalShow: Dispatch<SetStateAction<boolean>>;
  reactivateDate: string;
  handleReactivateDateChange: (date: ChangeEvent<HTMLInputElement>) => void;
  setRehabilitateDate: Dispatch<SetStateAction<string>>;
  handleActivatePassenger: () => void;
}

export default function ReactivateModal({
  passengerName,
  isReactivateDateSet,
  setIsReactivateDateSet,
  reactivateModalShow,
  setReactivateModalShow,
  reactivateDate,
  handleReactivateDateChange,
  setRehabilitateDate,
  handleActivatePassenger,
}: ReactivateModalInterface) {
  return (
    <MyModal
      show={reactivateModalShow}
      title={`Reativar passageiro ${passengerName}`}
      modalBody={(
        <ActionModalContainer>
          <FilterRadioButtonsContainer>
            <FilterRadioButton
              selected={!isReactivateDateSet}
              onClick={() => setIsReactivateDateSet(false)}
            >
              Reativar
            </FilterRadioButton>
            <FilterRadioButton
              selected={isReactivateDateSet}
              onClick={() => setIsReactivateDateSet(true)}
            >
              Reagendar data de reativação
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
          {isReactivateDateSet && (
            <OpacityAnimation delay={0.1}>
              <FormGroup>
                <label htmlFor="dayDisable">Selecione a data</label>
                <input type="date" value={reactivateDate} onChange={handleReactivateDateChange} />
              </FormGroup>
            </OpacityAnimation>
          )}
        </ActionModalContainer>
      )}
      closeButtonLabel="Fechar"
      actionButtonLabel="Confirmar"
      onClose={() => {
        setRehabilitateDate('');
        setIsReactivateDateSet(false);
        setReactivateModalShow(false);
      }}
      onAction={() => handleActivatePassenger()}
      isActionButtonDisabled={isReactivateDateSet ? (!reactivateDate) : false}
      type="activateAction"
      size='lg'
    />
  );
}
